module.exports = __webpack_public_path__ + "static/share-109642c1c1c7b5ad34f34121183ab6fc.png";